<template>
  <div v-if="loaderStore.isLoading" class="loader-wrapper">
    <div class="loader-content">
      <pn-spinner :size="loaderConfig.size ?? spinnerSize"></pn-spinner>
      <p v-if="loaderConfig.data?.text" :class="loaderConfig.data?.cssClass">
        {{ $t(loaderConfig.data?.text) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLoaderStore } from '@/store/loader';
import config from '@/config';
import { computed } from 'vue';

const loaderStore = useLoaderStore();
const loaderConfig = computed(() => loaderStore.loaderConfig);
const { VUE_LOADER_SPINNER_SIZE: spinnerSize } = config;
</script>

<style lang="scss" scoped>
.loader-wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.7);
}
.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
</style>
